<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { ExpRateTrendAnimator, type ExpRateTrendPresentation } from '@/ui/exp-rate-trend'

const props = withDefaults(defineProps<{ model?: ExpRateTrendPresentation | null; context: string; interactive?: boolean; running?: boolean }>(), { running: true })
const node = ref<HTMLElement>()
const open = ref(false)
const visible = ref(Boolean(props.model?.direction) && props.running)
const description = ref(props.model?.description ?? '')
let animator: ExpRateTrendAnimator | undefined
const update = () => {
  animator?.update(props.running === false ? null : props.model, props.context, props.running !== false)
  if (props.running === false) open.value = false
}
onMounted(() => {
  if (node.value) animator = new ExpRateTrendAnimator(node.value, model => {
    description.value = model?.description ?? ''
    visible.value = Boolean(model?.direction)
    if (!visible.value) open.value = false
  })
  update()
})
watch(() => [props.model, props.context, props.running], update, { flush: 'post' })
onBeforeUnmount(() => animator?.destroy())
</script>

<template>
  <el-popover v-if="interactive" :visible="open" role="dialog" placement="top" :width="320" :show-arrow="false" :teleported="true">
    <template #reference>
      <span ref="node" class="exp-rate-trend" :tabindex="visible ? 0 : -1" role="button"
        :aria-expanded="open" :aria-hidden="!visible"
        @mouseenter="open = visible" @mouseleave="open = false" @focus="open = visible"
        @blur="open = false" @click="open = visible" @keydown.enter.prevent="open = !open"
        @keydown.space.prevent="open = !open" @keydown.esc="open = false" />
    </template>
    <div class="exp-rate-trend-description">{{ description }}</div>
  </el-popover>
  <span v-else ref="node" class="exp-rate-trend" :aria-hidden="!visible" data-stream-measure />
</template>
